import FloatingCard from '@components/v2/ui/FloatingCard/FloatingCard';
import { memo } from 'react';
import LangEnum from '../../lang/LangEnum';
import { NpsTestIds } from '../../utils/testIds/Nps.testIds';
import NpsContainerContent from './components/NpsContainerContent';
import { NpsContextProvider, useNpsContext } from './contexts/Nps.context';

const NpsInnerContainer = () => {
  const { isNpsOpen, onClose } = useNpsContext();

  return (
    <FloatingCard
      isOpen={isNpsOpen}
      onClose={onClose}
      title={LangEnum.NPS_TITLE}
      testId={NpsTestIds.CONTAINER}
    >
      <NpsContainerContent />
    </FloatingCard>
  );
};

const NpsContainer = () => (
  <NpsContextProvider>
    <NpsInnerContainer />
  </NpsContextProvider>
);

export default memo(NpsContainer);
